import React from 'react';
import { IPaginationParams, IPaginationRequest } from './useRequest';

export interface IPagination {
    state: IPaginationParams,
    requestedPagination: IPaginationRequest,
    handlePageChange: (e: React.MouseEvent<HTMLButtonElement> | null, page: number) => void,
    updatePagination: (updateState: IPaginationParams) => void,
    reset: VoidFunction
}

export function usePagination (initialState?: Partial<IPaginationParams>) : IPagination {
    const [state, setState] = React.useState<IPaginationParams>({
        totalCount: initialState?.totalCount || 0,
        currentPage: initialState?.currentPage || 0,
        rowsPerPage: initialState?.rowsPerPage || 50,
        hasMore: false
    });

    const [requestedPagination, setRequestedPagination] = React.useState<IPaginationRequest>({
        requestedPage: initialState?.currentPage || 0,
        rowsPerPage: initialState?.rowsPerPage || 50
    });

    const handlePageChange = React.useCallback((e: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        setRequestedPagination({
            ...requestedPagination,
            requestedPage: page
        });
    }, [requestedPagination]);

    const updatePagination = React.useCallback((newState: IPaginationParams) => {
        setState(newState);
    }, []);

    const reset = React.useCallback(() => {
        setRequestedPagination({
            requestedPage: 0,
            rowsPerPage: initialState?.rowsPerPage || 50
        });
    }, [initialState]);

    return React.useMemo(() => ({
        state,
        requestedPagination,
        handlePageChange,
        updatePagination,
        reset
    }), [state, requestedPagination, handlePageChange, updatePagination, reset]);
}